<template>
  <div>
    <v-autocomplete
      v-model="select"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      @change="setPlayerName"
      :label="$t('searchPlayers')"
      item-text="name"
      item-value="name"
      prepend-icon="mdi-account-circle"
      filled
      solo-inverted
      clearable
      hide-details
      return-object
      @click:clear="clearable()"
    >
      <template v-slot:item="data">
        {{ data.item.name }}
      </template></v-autocomplete
    >
    <span class="caption ml-10">{{ $t("searchByName") }}</span>
  </div>
</template>
<script>
export default {
  name: "components-common-filter-autocomplete-players",
  data: () => ({
    select: null,
    search: null,
    isLoading: false,
    items: [],
  }),
  computed: {
    namePlayer() {
      return this.$store.state.filters.autocompleteNamePlayers.player_name;
    },
  },
  mounted() {
    this.select = this.$store.state.filters.autocompleteNamePlayers.player_name;
    if (this.$isAgent()) {
      this.getNamePlayersList();
    }
  },
  watch: {
    search() {
      // Items have already been loaded
      if (this.items.length > 0) return;
      if (this.isLoading) return;
      this.getNamePlayersList();
    },
    $route(val) {
      if (val.name == "AgentBetHistoric") {
        this.getNamePlayersList();
      }
    },
  },
  methods: {
    clearable() {
      this.$store.commit("setPlayerName", "");
    },

    setPlayerName(player) {
      if (!player) return;
      this.$store.commit("setPlayerName", player.name ? player.name : "");
    },

    async getNamePlayersList() {
      this.isLoading = true;
      try {
        const response = await this.$axios.get(
          "agent/clients/listClientsAgents"
        );
        // console.log(response.data.dados);
        this.items = response.data.dados;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
